var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-group-member" },
    [
      _c(
        "yxt-drawer",
        {
          class: {
            "yxtbiz-group-member-drawer--hidden": !_vm.show,
            "yxtbiz-group-member-drawer--transparent":
              _vm.currentPage !== "Main",
          },
          attrs: {
            visible: _vm.visible,
            "before-close": _vm.beforeClose,
            "show-close": false,
            wrapperClosable: false,
            modal: _vm.currentPage === "Main",
            size: "960",
            "custom-class": "yxtbiz-group-member-drawer",
            direction: "rtl",
          },
          on: { open: _vm.init },
        },
        [
          !(_vm.currentPage !== "Main" && _vm.back)
            ? _c("Main", _vm._b({}, "Main", _vm.bindData, false))
            : _vm._e(),
          _c(
            "yxt-drawer",
            {
              attrs: {
                visible: _vm.currentPage === "Quick",
                "append-to-body": true,
                "show-close": false,
                wrapperClosable: false,
                size: "480",
                "custom-class": "yxtbiz-group-member-drawer",
                direction: "rtl",
              },
            },
            [
              _vm.currentPage === "Quick"
                ? _c("Quick", _vm._b({}, "Quick", _vm.bindData, false))
                : _vm._e(),
            ],
            1
          ),
          _c(
            "yxt-drawer",
            {
              attrs: {
                visible: _vm.currentPage === "Group",
                "append-to-body": true,
                "show-close": false,
                wrapperClosable: false,
                size: "480",
                "custom-class": "yxtbiz-group-member-drawer",
                direction: "rtl",
              },
            },
            [
              _vm.currentPage === "Group"
                ? _c("Group", _vm._b({}, "Group", _vm.bindData, false))
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }